import { FC } from "react";
import { ValueContainerProps } from "react-select";
import classNames from "classnames";
import styles from "./styles.module.scss";
import { OptionItem } from "../../OptionItem";

/**
 * The select value container area.
 */
export const ValueContainer: FC<ValueContainerProps<OptionItem | null>> = (props) => {
  const { children, innerProps, selectProps } = props;

  const valueContainerClassName = classNames(styles.ValueContainer, "value-container", { opened: selectProps.menuIsOpen });

  return (
    <div {...innerProps} className={valueContainerClassName}>
      {children}
    </div>
  );
};
